// CORE-1750 (возврат QA 23.10) — подложка крупной кнопки «Пройти знакомство с
// платформой». Отдельным модулем без React: правило проверяется тестом, а
// компонент кнопки тянет провайдер тура и за ним AuthContext.
import { platformBackgrounds, PlatformTheme, surfaceFill } from '../styles/platformBackgrounds';
import { withAlpha } from '../utils/colorShade';

export type TourCtaState = 'rest' | 'hover' | 'pressed';

/** Тёплая подсветка под курсором и при нажатии — та же, что была у кнопки. */
const CTA_TINT = '#F26A36';
const CTA_TINT_ALPHA: Record<TourCtaState, number> = { rest: 0, hover: 0.09, pressed: 0.14 };

/**
 * CORE-1750 — подложка крупной кнопки: поверхность v4 своей темы и солнечный
 * контур поверх её контура 1px. Подсветка состояния ложится первым слоем
 * `background-image` — поверх градиента поверхности, иначе её не видно.
 */
export function tourCtaFill(
  theme: PlatformTheme,
  state: TourCtaState,
  outline: string,
): Record<string, unknown> {
  const surface = surfaceFill(theme);
  const alpha = CTA_TINT_ALPHA[state];
  const tinted = alpha > 0 && typeof surface.backgroundImage === 'string';
  return {
    ...surface,
    ...(tinted
      ? {
          backgroundImage: `linear-gradient(${withAlpha(CTA_TINT, alpha)},${withAlpha(CTA_TINT, alpha)}),${platformBackgrounds[theme].surfaceImage}`,
        }
      : null),
    borderWidth: 1.5,
    borderColor: outline,
  };
}
